import {precacheAndRoute as workbox_precaching_precacheAndRoute} from '/opt/homebrew/lib/node_modules/workbox-cli/node_modules/workbox-precaching/precacheAndRoute.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */








self.addEventListener('message', (event) => {
  if (event.data && event.data.type === 'SKIP_WAITING') {
    self.skipWaiting();
  }
});




/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "js/app.min.js",
    "revision": "d2298529e2e1a258609a0f5e783e2921"
  },
  {
    "url": "js/extensions.min.js",
    "revision": "3136b7d82b8c01e65b72a389b313a058"
  },
  {
    "url": "js/orgchart.min.js",
    "revision": "619d8c4dab47b81868916df31f55478b"
  },
  {
    "url": "js/stencils.min.js",
    "revision": "fb7151e9f9c7fe11447d36774985b644"
  },
  {
    "url": "js/shapes-14-6-5.min.js",
    "revision": "d61ee16aa1c1e928e7e8050d28ece5b3"
  },
  {
    "url": "js/math-print.js",
    "revision": "cf64f6a493a8cb5079f2b70813e478d7"
  },
  {
    "url": "index.html",
    "revision": "da0d9eb4984b2dbbdb6622c78f528a2a"
  },
  {
    "url": "open.html",
    "revision": "d71816b3b00e769fc6019fcdd6921662"
  },
  {
    "url": "styles/fonts/ArchitectsDaughter-Regular.ttf",
    "revision": "31c2153c0530e32553b31a49b3d70736"
  },
  {
    "url": "styles/grapheditor.css",
    "revision": "cc568cb69c7518030dbd8b27567e2b07"
  },
  {
    "url": "styles/atlas.css",
    "revision": "d627cfef208f13a9cff1670f143c6348"
  },
  {
    "url": "styles/dark.css",
    "revision": "fd2878ff29a6b68cb8dbfab17e32d649"
  },
  {
    "url": "js/dropbox/Dropbox-sdk.min.js",
    "revision": "4b9842892aa37b156db0a8364b7a83b0"
  },
  {
    "url": "js/onedrive/OneDrive.js",
    "revision": "505e8280346666f7ee801bc59521fa67"
  },
  {
    "url": "js/viewer-static.min.js",
    "revision": "fea583dba198a101c7501fd411d23532"
  },
  {
    "url": "connect/jira/editor-1-3-3.html",
    "revision": "a583c5c1dac9945f6f4087c880e26854"
  },
  {
    "url": "connect/jira/viewerPanel-1-3-12.html",
    "revision": "801fc4ef821f5a3986902998da85b53a"
  },
  {
    "url": "connect/jira/fullScreenViewer-1-3-3.html",
    "revision": "b20590b5ba995880eb6778e092a3fd50"
  },
  {
    "url": "connect/jira/viewerPanel.js",
    "revision": "b70ea4d572fe9d07867d955c408f5c27"
  },
  {
    "url": "connect/jira/spinner.gif",
    "revision": "7d857ab9d86123e93d74d48e958fe743"
  },
  {
    "url": "connect/jira/editor.js",
    "revision": "a109a49b6c8f23095fbc1a2a88912d3b"
  },
  {
    "url": "connect/jira/fullscreen-viewer-init.js",
    "revision": "94804f65483a6e7eb51dee97d0ae9d88"
  },
  {
    "url": "connect/jira/fullscreen-viewer.js",
    "revision": "8eceb2fe587296dd11f9c8f6eae34c20"
  },
  {
    "url": "plugins/connectJira.js",
    "revision": "4cefa13414e0d406550f3c073923080c"
  },
  {
    "url": "plugins/cConf-comments.js",
    "revision": "ee6764429bf47a8545aa1cedacee718e"
  },
  {
    "url": "plugins/cConf-1-4-8.js",
    "revision": "9b8a5842586a62ed627412626cf28545"
  },
  {
    "url": "connect/confluence/connectUtils-1-4-8.js",
    "revision": "17120161d4c7d9e0fc3d9a88d77e0c05"
  },
  {
    "url": "connect/new_common/cac.js",
    "revision": "cf63bf9103bafb9f34cf3ff624b918e8"
  },
  {
    "url": "connect/gdrive_common/gac.js",
    "revision": "78f85e79f15f56b8b8d83c90f4a15679"
  },
  {
    "url": "connect/onedrive_common/ac.js",
    "revision": "d10d4603e86da7c9af277dac832e8e06"
  },
  {
    "url": "connect/confluence/viewer-init.js",
    "revision": "84b1f6758f3c1a723b019c58af377027"
  },
  {
    "url": "connect/confluence/viewer.js",
    "revision": "0c2816b2c51984a097fc8109cd868b45"
  },
  {
    "url": "connect/confluence/viewer-1-4-42.html",
    "revision": "4a9a11f6de154cbd7a2df9e45790daf1"
  },
  {
    "url": "connect/confluence/macroEditor-1-4-8.html",
    "revision": "b2908e71f755a069fe6487e1e705736c"
  },
  {
    "url": "connect/confluence/includeDiagram-1-4-8.js",
    "revision": "90d1612e10c3ed94f3b355fbaf262a95"
  },
  {
    "url": "connect/confluence/includeDiagram.html",
    "revision": "4df629a5bfba840368ab8185ce27f439"
  },
  {
    "url": "connect/confluence/macro-editor.js",
    "revision": "51e513c65251b215aa78420c84623a18"
  },
  {
    "url": "math/es5/startup.js",
    "revision": "dc7130cdc866593293dbb5dde11ceb40"
  },
  {
    "url": "math/es5/core.js",
    "revision": "f71bc0bfb7d2ac8261747f97a5d47dd4"
  },
  {
    "url": "math/es5/ui/safe.js",
    "revision": "8c1fcfee7c879588ad409edcdd9cce53"
  },
  {
    "url": "math/es5/output/svg.js",
    "revision": "4f55967d16197ebb01b86356d8ab179a"
  },
  {
    "url": "math/es5/input/tex.js",
    "revision": "5c4f470da2ccb1acf85041fcecd6fff6"
  },
  {
    "url": "math/es5/input/asciimath.js",
    "revision": "c2d4076dd8e26d509bfe3a378e71cfa7"
  },
  {
    "url": "math/es5/output/svg/fonts/tex.js",
    "revision": "6eab785a3788ea805bd2b552d1f0aab8"
  },
  {
    "url": "resources/dia.txt",
    "revision": "19f59cd19defd1e5c80d71534e2c8be3"
  },
  {
    "url": "resources/dia_am.txt",
    "revision": "24d68a0dd72a9e69baa5539dc40a65ab"
  },
  {
    "url": "resources/dia_ar.txt",
    "revision": "fe6adf6515b083d48489b4c4b950245c"
  },
  {
    "url": "resources/dia_bg.txt",
    "revision": "925e6d42f88f11dc76d782e8b9eb3bdf"
  },
  {
    "url": "resources/dia_bn.txt",
    "revision": "2c2d1f4a02e5b2c63c5370dcce8a3c5e"
  },
  {
    "url": "resources/dia_bs.txt",
    "revision": "fe8e825336de041d0e351994ad46a04f"
  },
  {
    "url": "resources/dia_ca.txt",
    "revision": "7e26de88a39270c359646181f9573afe"
  },
  {
    "url": "resources/dia_cs.txt",
    "revision": "0860d6c3220c663b46fdb6c5b46729e3"
  },
  {
    "url": "resources/dia_da.txt",
    "revision": "fb1d20cc401620c5a35a061e982470a0"
  },
  {
    "url": "resources/dia_de.txt",
    "revision": "5e740eb757ace31fa18e7d2d3d6213e1"
  },
  {
    "url": "resources/dia_el.txt",
    "revision": "922af558a97d6d3e47fca809c625a825"
  },
  {
    "url": "resources/dia_eo.txt",
    "revision": "43722fbade390f941d98208b378cb7b2"
  },
  {
    "url": "resources/dia_es.txt",
    "revision": "0ddb0a38b554a912612fe81c74d8eef6"
  },
  {
    "url": "resources/dia_et.txt",
    "revision": "153ba5c4a0329ef0a12bf2b0add01504"
  },
  {
    "url": "resources/dia_eu.txt",
    "revision": "3b3230ecb03eafd1584235337f8a162d"
  },
  {
    "url": "resources/dia_fa.txt",
    "revision": "11fcc3177332639bfc06710397e660e6"
  },
  {
    "url": "resources/dia_fi.txt",
    "revision": "1430d1b365b770ab242fffd7ce99adbe"
  },
  {
    "url": "resources/dia_fil.txt",
    "revision": "4eda22e1fd72efaecd59c0929b7852a2"
  },
  {
    "url": "resources/dia_fr.txt",
    "revision": "55d73a404c6dfbd51ef1c5f8f8edc07a"
  },
  {
    "url": "resources/dia_gl.txt",
    "revision": "f5f8f6555d4d92921d79ea66af1e9742"
  },
  {
    "url": "resources/dia_gu.txt",
    "revision": "65f11ced857ba16559ca96c4c0ffd6f0"
  },
  {
    "url": "resources/dia_he.txt",
    "revision": "cc2fedf06b670745eff6da2d1b6d43ca"
  },
  {
    "url": "resources/dia_hi.txt",
    "revision": "91042f5f38dcd13e7d36faa077bd3293"
  },
  {
    "url": "resources/dia_hr.txt",
    "revision": "b7bde0e78acc9d82c1d0a003b906dba7"
  },
  {
    "url": "resources/dia_hu.txt",
    "revision": "0c651c3f9c83f0de420fe6b8ec7b8ed3"
  },
  {
    "url": "resources/dia_id.txt",
    "revision": "f2fe508d397c0976932307b22d6175cb"
  },
  {
    "url": "resources/dia_it.txt",
    "revision": "26a212864e4f525925a98e4c65b4ae6c"
  },
  {
    "url": "resources/dia_ja.txt",
    "revision": "16ec7674a9ea19bc129458f30350a14c"
  },
  {
    "url": "resources/dia_kn.txt",
    "revision": "e193dba8ae015603005241c629ce7d11"
  },
  {
    "url": "resources/dia_ko.txt",
    "revision": "130f10ba808e3d1cf0278b88bc6cd9cc"
  },
  {
    "url": "resources/dia_lt.txt",
    "revision": "7ba04ef1fee83fea16c31712280331da"
  },
  {
    "url": "resources/dia_lv.txt",
    "revision": "7a532521c0d9117a4b7ec68a5f88f3fd"
  },
  {
    "url": "resources/dia_ml.txt",
    "revision": "f92bd040fac41eefd1c77968b2696bfd"
  },
  {
    "url": "resources/dia_mr.txt",
    "revision": "30174abb165da5ae59b4efb2d4cf5791"
  },
  {
    "url": "resources/dia_ms.txt",
    "revision": "7d714ada0c421c3a33c4ff011718efee"
  },
  {
    "url": "resources/dia_my.txt",
    "revision": "19f59cd19defd1e5c80d71534e2c8be3"
  },
  {
    "url": "resources/dia_nl.txt",
    "revision": "4ab1f3ad31c725261e7c0fa724343343"
  },
  {
    "url": "resources/dia_no.txt",
    "revision": "6d0680d26db911b426f46821823c7f1c"
  },
  {
    "url": "resources/dia_pl.txt",
    "revision": "a455917c71eba18c5fb9bfb2b87ab78b"
  },
  {
    "url": "resources/dia_pt-br.txt",
    "revision": "1f8fe81a14ea1d390f0188e22bb83d80"
  },
  {
    "url": "resources/dia_pt.txt",
    "revision": "dabdf8498f893a7ec6cdb4474ec4a507"
  },
  {
    "url": "resources/dia_ro.txt",
    "revision": "006c9e6c9a5f75df5b032a18163ccb2d"
  },
  {
    "url": "resources/dia_ru.txt",
    "revision": "692d1d4166d2c7db816e0c4d7b5d6661"
  },
  {
    "url": "resources/dia_si.txt",
    "revision": "19f59cd19defd1e5c80d71534e2c8be3"
  },
  {
    "url": "resources/dia_sk.txt",
    "revision": "95af3cd2a19edce159f8924390a79e31"
  },
  {
    "url": "resources/dia_sl.txt",
    "revision": "e99a3669d73c1486f5275511ad0a7db3"
  },
  {
    "url": "resources/dia_sr.txt",
    "revision": "31fe3bf1ce9262942414ad4985ad0f88"
  },
  {
    "url": "resources/dia_sv.txt",
    "revision": "74231b0c8825f52b695d332efece6096"
  },
  {
    "url": "resources/dia_sw.txt",
    "revision": "c259203f497c0f78f79887c4d22c12ac"
  },
  {
    "url": "resources/dia_ta.txt",
    "revision": "a1b0f3a05b61b8e1edf1a2c5757fad74"
  },
  {
    "url": "resources/dia_te.txt",
    "revision": "f3f8c1bf453a92b81610363d6b752dbe"
  },
  {
    "url": "resources/dia_th.txt",
    "revision": "ac5165f521fd411943d7cb3f75486275"
  },
  {
    "url": "resources/dia_tr.txt",
    "revision": "1d5cc60f28a914dd8214b41c1a042c71"
  },
  {
    "url": "resources/dia_uk.txt",
    "revision": "990dee6622b2bf530fea52b9d50f285f"
  },
  {
    "url": "resources/dia_vi.txt",
    "revision": "177bf7516602cc5c986842896ea1dcb6"
  },
  {
    "url": "resources/dia_zh-tw.txt",
    "revision": "8adfaa966152e9b996e25dde6301a951"
  },
  {
    "url": "resources/dia_zh.txt",
    "revision": "e44fb398c5b2c40d789474036723e8f7"
  },
  {
    "url": "favicon.ico",
    "revision": "fab2d88b37c72d83607527573de45281"
  },
  {
    "url": "images/manifest.json",
    "revision": "389fa448cb99794bece27ffcb216abee"
  },
  {
    "url": "images/logo.png",
    "revision": "89630b64b911ebe0daa3dfe442087cfa"
  },
  {
    "url": "images/drawlogo.svg",
    "revision": "4bf4d14ebcf072d8bd4c5a1c89e88fc6"
  },
  {
    "url": "images/drawlogo48.png",
    "revision": "8b13428373aca67b895364d025f42417"
  },
  {
    "url": "images/drawlogo-gray.svg",
    "revision": "0aabacbc0873816e1e09e4736ae44c7d"
  },
  {
    "url": "images/drawlogo-text-bottom.svg",
    "revision": "f6c438823ab31f290940bd4feb8dd9c2"
  },
  {
    "url": "images/default-user.jpg",
    "revision": "2c399696a87c8921f12d2f9e1990cc6e"
  },
  {
    "url": "images/logo-flat-small.png",
    "revision": "4b178e59ff499d6dd1894fc498b59877"
  },
  {
    "url": "images/apple-touch-icon.png",
    "revision": "73da7989a23ce9a4be565ec65658a239"
  },
  {
    "url": "images/favicon-16x16.png",
    "revision": "1a79d5461a5d2bf21f6652e0ac20d6e5"
  },
  {
    "url": "images/favicon-32x32.png",
    "revision": "e3b92da2febe70bad5372f6f3474b034"
  },
  {
    "url": "images/android-chrome-196x196.png",
    "revision": "f8c045b2d7b1c719fda64edab04c415c"
  },
  {
    "url": "images/android-chrome-512x512.png",
    "revision": "959b5fac2453963ff6d60fb85e4b73fd"
  },
  {
    "url": "images/delete.png",
    "revision": "5f2350f2fd20f1a229637aed32ed8f29"
  },
  {
    "url": "images/droptarget.png",
    "revision": "bbf7f563fb6784de1ce96f329519b043"
  },
  {
    "url": "images/help.png",
    "revision": "9266c6c3915bd33c243d80037d37bf61"
  },
  {
    "url": "images/download.png",
    "revision": "35418dd7bd48d87502c71b578cc6c37f"
  },
  {
    "url": "images/logo-flat.png",
    "revision": "038070ab43aee6e54a791211859fc67b"
  },
  {
    "url": "images/google-drive-logo.svg",
    "revision": "5d9f2f5bbc7dcc252730a0072bb23059"
  },
  {
    "url": "images/onedrive-logo.svg",
    "revision": "3645b344ec0634c1290dd58d7dc87b97"
  },
  {
    "url": "images/dropbox-logo.svg",
    "revision": "e6be408c77cf9c82d41ac64fa854280a"
  },
  {
    "url": "images/github-logo.svg",
    "revision": "a1a999b69a275eac0cb918360ac05ae1"
  },
  {
    "url": "images/gitlab-logo.svg",
    "revision": "0faea8c818899e58533e153c44b10517"
  },
  {
    "url": "images/trello-logo.svg",
    "revision": "006fd0d7d70d7e95dc691674cb12e044"
  },
  {
    "url": "images/osa_drive-harddisk.png",
    "revision": "b954e1ae772087c5b4c6ae797e1f9649"
  },
  {
    "url": "images/osa_database.png",
    "revision": "c350d9d9b95f37b6cfe798b40ede5fb0"
  },
  {
    "url": "images/google-drive-logo-white.svg",
    "revision": "f329d8b1be7778515a85b93fc35d9f26"
  },
  {
    "url": "images/dropbox-logo-white.svg",
    "revision": "4ea8299ac3bc31a16f199ee3aec223bf"
  },
  {
    "url": "images/onedrive-logo-white.svg",
    "revision": "b3602fa0fc947009cff3f33a581cff4d"
  },
  {
    "url": "images/github-logo-white.svg",
    "revision": "537b1127b3ca0f95b45782d1304fb77a"
  },
  {
    "url": "images/gitlab-logo-white.svg",
    "revision": "5fede9ac2f394c716b8c23e3fddc3910"
  },
  {
    "url": "images/trello-logo-white-orange.svg",
    "revision": "e2a0a52ba3766682f138138d10a75eb5"
  },
  {
    "url": "images/logo-confluence.png",
    "revision": "ed1e55d44ae5eba8f999aba2c93e8331"
  },
  {
    "url": "images/logo-jira.png",
    "revision": "f8d460555a0d1f87cfd901e940666629"
  },
  {
    "url": "images/clear.gif",
    "revision": "db13c778e4382e0b55258d0f811d5d70"
  },
  {
    "url": "images/spin.gif",
    "revision": "487cbb40b9ced439aa1ad914e816d773"
  },
  {
    "url": "images/checkmark.gif",
    "revision": "ba764ce62f2bf952df5bbc2bb4d381c5"
  },
  {
    "url": "images/hs.png",
    "revision": "fefa1a03d92ebad25c88dca94a0b63db"
  },
  {
    "url": "images/aui-wait.gif",
    "revision": "5a474bcbd8d2f2826f03d10ea44bf60e"
  },
  {
    "url": "mxgraph/css/common.css",
    "revision": "618b42f0bde0c7685e04811c25dc2b3e"
  },
  {
    "url": "mxgraph/images/expanded.gif",
    "revision": "2b67c2c035af1e9a5cc814f0d22074cf"
  },
  {
    "url": "mxgraph/images/collapsed.gif",
    "revision": "73cc826da002a3d740ca4ce6ec5c1f4a"
  },
  {
    "url": "mxgraph/images/maximize.gif",
    "revision": "5cd13d6925493ab51e876694cc1c2ec2"
  },
  {
    "url": "mxgraph/images/minimize.gif",
    "revision": "8957741b9b0f86af9438775f2aadbb54"
  },
  {
    "url": "mxgraph/images/close.gif",
    "revision": "8b84669812ac7382984fca35de8da48b"
  },
  {
    "url": "mxgraph/images/resize.gif",
    "revision": "a6477612b3567a34033f9cac6184eed3"
  },
  {
    "url": "mxgraph/images/separator.gif",
    "revision": "7819742ff106c97da7a801c2372bbbe5"
  },
  {
    "url": "mxgraph/images/window.gif",
    "revision": "fd9a21dd4181f98052a202a0a01f18ab"
  },
  {
    "url": "mxgraph/images/window-title.gif",
    "revision": "3fb1d6c43246cdf991a11dfe826dfe99"
  },
  {
    "url": "mxgraph/images/button.gif",
    "revision": "00759bdc3ad218fa739f584369541809"
  },
  {
    "url": "mxgraph/images/point.gif",
    "revision": "83a43717b284902442620f61bc4e9fa6"
  }
], {
  "ignoreURLParametersMatching": [/.*/]
});








